module.exports = __webpack_public_path__ + "static/media/slider.2ecd8d52.jpg";